import * as React from "react"
import { SVGProps } from "react"

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.167 30.955l-9.5-10.364L9.042 18l7.125 7.773L31.458 9.09l2.375 2.59-17.666 19.274z"
    />
  </svg>
)
